<template>
    <div>
        <public-title showBack >门店资料</public-title>
        <div class="load-area">
            <div class="mb-4 d-start-start text-left w-100 text-blue cursor-pointer"  @click="goStoreDetail(infoData.store_type,infoData.store_id)">
                    门店详情
            </div>
            <div class="mb-4 d-start-start text-left w-100 text-blue cursor-pointer" @click="checkDetail(infoData)">
                    用户详情
            </div>
            <h4 class="bg-base p-3 text-left">基本信息</h4>
            <div class="d-center-between flex-wrap pt-3 pb-3">
                <div class="w-40 mb-4 d-start-start text-left">
                    <left-text leftText="门店类型"/>
                    <label>
                        <span class="mr-3">{{infoData.store_type| formatVar('StoreType')}} </span>
                    </label>
                </div>
                <div class="w-40 mb-4 d-start-start text-left">
                    <left-text leftText="所属类型"/>
                    <label>
                        <span class="mr-3">{{infoData.type==1?'企业':'个人'}} </span>
                    </label>
                </div>
                <div class="w-40 mb-4 d-center-start">
                    <left-text :leftText="infoData.type==1?'企业名称':'个人名称'"/>
                    <label>
                        <span class="mr-3">{{infoData.truename}} </span>
                    </label>
                </div>
                <div class="w-40 mb-4 d-start-start text-left">
                    <left-text leftText="开户银行"/>
                    <label>
                        <span class="mr-3">{{infoData.bank_name}} </span>
                    </label>
                </div>
                <div class="w-40 mb-4 d-center-start">
                    <left-text leftText="银行卡号"/>
                    <label>
                        <span class="mr-3">{{infoData.bank_card}} </span>
                    </label>
                </div>
                <div class="mb-4 d-start-start text-left w-100">
                    <left-text leftText="开户支行名称"/>
                    {{infoData.city_name}}省{{infoData.province_name}}市{{infoData.district_name}}{{infoData.branch}}
                    <!-- <i class="el-icon-location location" v-if="storeInfo.type==3&&StoreBasicInfo.longitude" @click="mapclock(StoreBasicInfo.longitude,StoreBasicInfo.latitude,StoreBasicInfo.title)"></i> -->
                </div>
                <div class="mb-4 d-start-start text-left w-40">
                    <left-text leftText="备注"/>
                    {{infoData.remark}}
                </div>
                <div class="mb-4 d-start-start text-left w-40">
                    <left-text leftText="认证状态"/>
                    <span :class="[infoData.verify===1?'text-success':'text-danger']">{{infoData.verify | formatVar('verifyType')}}</span>
                </div>
                <div class="mb-4 d-start-start text-left w-40" v-if="infoData.type==2">
                    <left-text leftText="企业授权证明"/>
                    <el-image 
                        style="width: 100px; height: 100px"
                        :src="ImgPreUrl+infoData.pic" 
                        >
                    </el-image>
                </div>
            </div>
            <h4 class="bg-base p-3 text-left">操作</h4>
            <div class="mt-4" >
                <el-button type="success" @click="passStore">通过审核</el-button>
                <el-button type="danger"  @click="refuseVerify = true">审核拒绝</el-button>
            </div>
        </div>
        <el-dialog title="选择拒绝原因" :visible.sync="refuseVerify" center width="670px" top="17%">
            <el-radio-group  v-model="refuseValue">
                <el-radio :label="item"  v-for="(item,index) in refuseArr" :key="index" class="mb-2 ml-0 mr-4">{{item}}</el-radio>
                <p class="d-center-start" v-if="refuseValue==='其他'">其他：
                    <el-input v-model="verifyRemark" class="w-100 mt-2"  placeholder="请输入拒绝原因"/>
                </p>
            </el-radio-group>
            <div slot="footer">
                <el-button @click="refuseVerify = false">取 消</el-button>
                <el-button type="primary" @click="verifyControl">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="用户详情" :visible.sync="showDetail" center :show-close="false">
            <div class="d-flex flex-wrap">
            <div class="d-center-start w-50 mb-3" v-for="item in showDetailArr" :key="item.name">
                <left-text :leftText="item.name"/><span v-html="currentItem[item.value]"></span>
            </div>
            <div class="d-center-start w-50 mb-3">
                <left-text leftText="账号密码"/>
                <span v-show="showPassword" class="mr-2">{{currentItem.password}}</span>
                <i class="iconfont text-link" @click="showPassword = !showPassword"
                :class="[showPassword ? 'icon-yanjing-zheng' : 'icon-yanjing-bi']"></i>
            </div>
            </div>
            <el-button slot="footer" type="primary" @click="showDetail = false">确 定</el-button>
        </el-dialog>
    </div>
</template>
<script>
  import { mapGetters,mapMutations, mapActions,mapState} from 'vuex'
    export default {
        name: 'addBankcard',
        data() {
            return {
                infoData:{},
                refuseVerify:false,
                refuseValue:'',
                verifyRemark:'',
                refuseArr: [
                    '开户银行有误',
                    '银行卡号有误',
                    '授权证明有误',
                    '开户支行有误',
                    '其他'
                ],
                showDetail:false,
                showPassword:false,
                showDetailArr:[
                    {name:'用户姓名',value:'truename'},{name:'注册来源',value:'trace'},{name:'用户类型',value:'type'},
                    {name:'上次登录时间',value:'login_time'},{name:'手机号',value:'mobile'},
                    {name:'绑定微信',value:'wechat_openid'},{name:'注册时间',value:'reg_time'},{name:'登录次数',value:'num'},
                    {name:'职位名称',value:'position_name'},{name:'账号主体',value:'title'}
                ],
                currentItem:{},  
            }
        },
        mounted() {
            this.Details(this.$route.query.id)
        },
        computed: {
            ...mapState(['AdminDataDetail']),
        },
        methods:{
            ...mapActions(['addStoreBankcard','getStoreBankcardDetails','reviewBankcard','getItemDetail']),
            /*获取银行卡详情*/
            Details(id){
                console.log(id);
                this.getStoreBankcardDetails({
                id:id,
                successFun: (e) => {
                    this.infoData = e;
                    console.log(e);
                }
                });
            },
            //通过认证
            passStore(){
                this._confirm('已向该银行卡打款0.01元？',async () => {
                    this.reviewBankcard({id:this.$route.query.id,action_flag:1})
                })
            },
            //查看门店详情页
            goStoreDetail(store_type,id) {
                    let routeUrl = this.$router.resolve({name:'StoreDetail',query:{type:store_type,id,none:1}});
                    window.open(routeUrl.href, '_blank');
            },
            //用户详情情页
            async checkDetail(item) {
                if (!this.$GFUN.powerIsInArray([80])) { this._alert('您没有相关权限！',null,'error'); return; }
                await this.getItemDetail({
                type:'userDetail',
                data:{
                    uid:item.uid,
                    // store_type:item.type
                }
                })
                this.currentItem = {
                ...this.AdminDataDetail,
                wechat_openid:` ${item.wechat_openid!=item.uid ? '已绑定' : '未绑定'}`,
                type:this.$options.filters['formatVar'](item.type,'StoreType'),
                trace:this.$options.filters['formatVar'](this.AdminDataDetail.trace,'traces'),
                login_time:item.login_time > 0 ? this.$options.filters['formatTimestamp'](item.login_time,1) : '从未登录',
                reg_time:this.$options.filters['formatTimestamp'](this.AdminDataDetail.reg_time,1)
                };
                this.showDetail = true;
            },
            //拒绝通过
            verifyControl(){

                if (!this.refuseValue) {
                    this._alert('请选择拒绝理由',null,'error');
                    return;
                }
                if (this.refuseValue === '其他'&& !this.verifyRemark) {
                    this._alert('请填写其他理由',null,'error');
                    return;
                }
                let data = {
                    id:this.$route.query.id,
                    action_flag:2,
                }
                data.action_remark = this.refuseValue === '其他' ? this.verifyRemark : this.refuseValue;
                this._confirm('确认操作么？',() => {
                    this.reviewBankcard(data)
                })
                
            },
        }
    }
</script>